/* ─── GRAVITY STUDIO — GLOBAL ANIMATIONS ─── */
(function () {
  'use strict';

  /* Scroll reveal with IntersectionObserver */
  var ro = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('gs-in');
        ro.unobserve(e.target);
      }
    });
  }, { threshold: 0.06, rootMargin: '0px 0px -24px 0px' });

  function observeRevs() {
    document.querySelectorAll('.gs-rev:not(.gs-in)').forEach(function (el) {
      ro.observe(el);
    });
  }

  /* Watch for dynamically injected .gs-rev elements (e.g. product-recommendations AJAX) */
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('gs-rev') && !node.classList.contains('gs-in')) {
          ro.observe(node);
        }
        node.querySelectorAll && node.querySelectorAll('.gs-rev:not(.gs-in)').forEach(function (el) {
          ro.observe(el);
        });
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });

  /* GSAP counter animation */
  function initCounters() {
    if (typeof gsap === 'undefined') return;
    document.querySelectorAll('[data-gs-counter]').forEach(function (el) {
      var target = parseInt(el.dataset.gsCounter, 10);
      ScrollTrigger.create({
        trigger: el,
        start: 'top 85%',
        once: true,
        onEnter: function () {
          gsap.fromTo({ val: 0 }, { val: target, duration: 1.8, ease: 'power2.out',
            onUpdate: function () {
              el.textContent = Math.round(this.targets()[0].val);
            }
          });
        }
      });
    });
  }

  /* GSAP ScrollTrigger reveals (more sophisticated than CSS) */
  function initGsapReveal() {
    if (typeof gsap === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);

    /* Stagger children on section enter */
    document.querySelectorAll('[data-gs-stagger]').forEach(function (parent) {
      var children = parent.querySelectorAll('[data-gs-stagger-child]');
      if (!children.length) return;
      gsap.set(children, { opacity: 0, y: 24 });
      ScrollTrigger.create({
        trigger: parent,
        start: 'top 80%',
        once: true,
        onEnter: function () {
          gsap.to(children, { opacity: 1, y: 0, duration: 0.7, stagger: 0.1, ease: 'power3.out' });
        }
      });
    });

    initCounters();
  }

  /* Header nav — open submenus on hover */
  function initNavHover() {
    var items = document.querySelectorAll(
      '.header__inline-menu details, .header__submenu-wrapper details, nav details'
    );
    items.forEach(function (d) {
      var timer;
      d.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        d.setAttribute('open', '');
      });
      d.addEventListener('mouseleave', function () {
        timer = setTimeout(function () { d.removeAttribute('open'); }, 140);
      });
    });
  }

  /* Header shrink on scroll */
  function initHeaderScroll() {
    var hdr = document.querySelector('.header-wrapper');
    if (!hdr) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          if (window.scrollY > 80) {
            hdr.style.background = 'rgba(10,10,12,.92)';
            hdr.style.backdropFilter = 'blur(18px)';
            hdr.style.webkitBackdropFilter = 'blur(18px)';
            hdr.style.boxShadow = '0 1px 0 rgba(255,255,255,.06)';
          } else {
            hdr.style.background = 'transparent';
            hdr.style.backdropFilter = 'none';
            hdr.style.webkitBackdropFilter = 'none';
            hdr.style.boxShadow = 'none';
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  function init() {
    observeRevs();
    initNavHover();
    initHeaderScroll();
    if (typeof gsap !== 'undefined') {
      initGsapReveal();
    } else {
      window.addEventListener('load', function () {
        if (typeof gsap !== 'undefined') initGsapReveal();
      });
    }

    /* Shopify section observer — re-check on section add */
    document.addEventListener('shopify:section:load', observeRevs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
